<template>
  <div id="order-wrapper" >
    <!--begin --- header ---begin  -->
    <div class="h-title-con">
      <div class="h-title">
        <span class="title-text"><span class="title-tip"></span>订单创建</span>
      </div>
      <div class="h-button-warpper">
        <el-button size="small" @click="save" type="primary">发送</el-button>
        <el-button size="small" @click="reset()" type="primary">重置</el-button>
      </div>
    </div>
    <!--end --- header ---end  -->
    <!--begin --- content ---begin  -->
    <div class="white-bg-radius sys-content w-label" id="orderCheck">
      <el-card class="box-card" >
        <el-form :model="ruleForm" :rules="rules" ref="form"
                 label-position="right" label-width="190px" class="demo-ruleForm" >
          <el-form-item label="开单序号：" prop="validId" class="ww-input-dia">
            <el-input v-model="ruleForm.validId" placeholder="请输入开单序号"></el-input>
          </el-form-item>
          <el-form-item label="订单编码：" prop="bstnk" class="ww-input-dia">
            <el-input v-model="ruleForm.bstnk" placeholder="请输入订单编码"></el-input>
          </el-form-item>
          <el-form-item label="SAP开单客户代号：" prop="kunnr">
            <el-input v-model="ruleForm.kunnr" placeholder="请输入SAP开单客户代号"></el-input>
          </el-form-item>
          <el-form-item label="达能送货分公司代号：" prop="vkorg1">
            <el-input v-model="ruleForm.vkorg1" placeholder="请输入达能送货分公司代号"></el-input>
          </el-form-item>
          <el-form-item label="达能开单分公司代号：" prop="vkorg">
            <el-input v-model="ruleForm.vkorg" placeholder="请输入达能开单分公司代号"></el-input>
          </el-form-item>
          <el-form-item label="达能开单渠道分销渠道代号：" prop="vtweg">
            <el-input v-model="ruleForm.vtweg" placeholder="请输入达能开单渠道分销渠道代号"></el-input>
          </el-form-item>
           <el-form-item label="达能开单渠道产品组代号：" prop="spart">
            <el-input v-model="ruleForm.spart" placeholder="请输入达能开单渠道产品组代号"></el-input>
          </el-form-item>
          <el-form-item label="SAP开单送达方代号：" prop="kunnr1">
            <el-input v-model="ruleForm.kunnr1" placeholder="请输入SAP开单送达方代号"></el-input>
          </el-form-item>
          <el-form-item label="是否工厂代发货：" prop="isFactdev">
            <el-radio-group v-model="ruleForm.isFactdev">
              <el-radio v-for=" (item,index) in statusList" :key="index" :label="item.value">{{item.label}}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="开单订单日期：" prop="zdate">
            <el-date-picker
              v-model="ruleForm.zdate"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyyMMdd"
              placeholder="选择开单订单日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="行项目：" >
             <el-button size="small" @click="add" type="primary">新增</el-button>
          </el-form-item>
          <div class="tabWarp" >
            <el-table
              :data="ruleForm.list"
              border
              style="width: 100%">
              <el-table-column
                prop="validId"
                label="开单序号"
                align="center"
                width="200"
               >
                <template slot-scope="{column,row,$index}">
                  <el-input v-model="ruleForm.list[$index].validId"></el-input>
                </template>
              </el-table-column>
              <el-table-column
                prop="validNo"
                label="订单行号"
                align="center"
                width="200"
                >
                <template slot-scope="{column,row,$index}">
                  <el-input v-model="ruleForm.list[$index].validNo"></el-input>
                </template>
              </el-table-column>
              <el-table-column
                prop="matnr"
                align="center"
                width="200"
                label="达能物料代号">
                <template slot-scope="{column,row,$index}">
                  <el-input v-model="ruleForm.list[$index].matnr"></el-input>
                </template>
              </el-table-column>
              <el-table-column
                prop="isComb"
                align="center"
                width="200"
                label="是否共卖品项">
                <template slot-scope="{column,row,$index}">
                  <el-radio-group v-model="ruleForm.list[$index].isComb">
                  <el-radio v-for=" (item,index) in statusList" :key="index" :label="item.value">{{item.label}}</el-radio>
                </el-radio-group>
                </template>
              </el-table-column>
              <el-table-column
                prop="abdat"
                label="允收生产日期"
                align="center"
                width="200"
              >
                <template slot-scope="{column,row,$index}">
                  <el-date-picker
                    type="date"
                    v-model="ruleForm.list[$index].abdat"
                    format="yyyy-MM-dd"
                    value-format="yyyyMMdd"
                    placeholder="选择日期">
                  </el-date-picker>
                </template>
              </el-table-column>
              <el-table-column
                prop="lgort"
                align="center"
                width="200"
                label="SAP返回仓别">
                <template slot-scope="{column,row,$index}">
                  <el-input v-model="ruleForm.list[$index].lgort"></el-input>
                </template>
              </el-table-column>
              <el-table-column
                prop="cmpre1"
                align="center"
                width="200"
                label="SAP订货箱数开单金额（原始）">
                <template slot-scope="{column,row,$index}">
                  <el-input v-model="ruleForm.list[$index].cmpre1"></el-input>
                </template>
              </el-table-column>
              <el-table-column
                prop="cmpre2"
                align="center"
                width="200"
                label="SAP订货箱数开单金额（修改后）">
                <template slot-scope="{column,row,$index}">
                  <el-input v-model="ruleForm.list[$index].cmpre2"></el-input>
                </template>
              </el-table-column>
              <el-table-column
                prop="kwmeng1"
                align="center"
                width="200"
                label="SAP订单箱数">
                <template slot-scope="{column,row,$index}">
                  <el-input v-model="ruleForm.list[$index].kwmeng1"></el-input>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                label="操作">
                <template slot-scope="{column,row,$index}">
                  <el-button size="mini" @click="remove($index)" type="primary">删除</el-button>
                </template>
              </el-table-column>
            </el-table>

          </div>
          <div class="tabWarp"  >
            <label style="min-width:100px;">
            返回结果：
            </label>
            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" v-model="ruleForm.remark">
            </el-input>
          </div>
        </el-form>
      </el-card>

    </div>

  </div>

</template>
<script>
  import { mapGetters } from 'vuex';
  import commonMixin from '@/mixins/common.js';
  import { methodPost, methodGet } from "../../api/request.js";
  export default {
    name: 'addOrganization',
    mixins: [commonMixin],
    data() {
      return {
        statusList: [
          { label: 'Y', value: 'Y' },
          { label: 'N', value: 'N' }
        ],
        ruleForm: {
          bstnk: '',
          isFactdev: 1,
          kunnr: '',
          kunnr1: '',
          spart: '',
          validId: '',
          vkorg: '',
          vkorg1: '',
          vtweg: "",
          zdate: "",
          remark: '',
          list: [
            {
              validId: '', validNo: '', matnr: '', isComb: 1, abdat: '', lgort: '', cmpre1: '', cmpre2: '', kwmeng1: ''
            }
          ] },
        rules: {
          validId: [
            { required: true, message: '此项为必填项', trigger: 'blur' }
          ],
          zdate: [
            { required: true, message: '此项为必填项', trigger: 'blur' }
          ],
          isFactdev: [
            { required: true, message: '此项为必填项', trigger: 'blur' }
          ]

        }

      }
    },
    methods: {
      back(isRefresh) {
        const path = '/organizationManagement/index'
        this.goBack(path)
        if (isRefresh) {
          this.$nextTick(() => {
            this.$eventBus.$emit('refresh-custom-table')
          })
        }
      },
      reset() {
        this.ruleForm.bstnk = '';
        this.ruleForm.isFactdev = '';
        this.ruleForm.kunnr = '';
        this.ruleForm.kunnr1 = '';
        this.ruleForm.spart = '';
        this.ruleForm.validId = '';
        this.ruleForm.vkorg = '';
        this.ruleForm.vkorg1 = '';
        this.ruleForm.vtweg = '';
        this.ruleForm.zdate = '';
        this.ruleForm.list = [{ validId: '', validNo: '', matnr: '', isComb: 1, abdat: '', lgort: '', cmpre1: '', cmpre2: '', kwmeng1: '' }]
        this.ruleForm.remark = '';
      },
      save() {
        this.$refs.form.validate(valid => {
          console.log(valid)
          if (valid) {
            this.submitForm()
          } else {
            console.log('error submit!!')
          }
        })
      },
      submitForm() {
        let URL
        if (this.ruleForm.id) {
          URL = '/sysOrganize/modifyOrganize'
        } else {
          URL = '/material/initOrderData'
        }
        const params = {
          type: '2',
          orderCreate: { bstnk: this.ruleForm.bstnk,
            isFactdev: this.ruleForm.isFactdev,
            kunnr: this.ruleForm.kunnr,
            kunnr1: this.ruleForm.kunnr1,
            spart: this.ruleForm.spart,
            validId: this.ruleForm.validId,
            vkorg: this.ruleForm.vkorg,
            vkorg1: this.ruleForm.vkorg1,
            vtweg: this.ruleForm.vtweg,
            zdate: this.ruleForm.zdate,
            orderCreateItem: this.ruleForm.list
          }

        }
        methodPost(URL, params).then(res => {
          console.log(1111)
          if (res.code === 0) {
            // this.$message.success(`${this.ruleForm.id ? '发送' : '创建'}成功`)
            this.ruleForm.remark = res.data;
            // this.back(true)
          } else {
            this.$message.error(res.message || '保存出错，请稍后再试')
          }
        })
      },
      // 添加
      add() {
        this.ruleForm.list.push(
          { validId: '', validNo: '', matnr: '', isComb: 1, abdat: '', lgort: '', cmpre1: '', cmpre2: '', kwmeng1: '' }
        )
      },
      // 删除
      remove(index) {
        this.ruleForm.list.splice(index, 1)
      },
      // 出现弹框里边的方法
      editEvent(val) {
        methodGet('/sysOrganize/getOrganizeById/' + val).then(res => {
          if (res.code === 0) {
            this.ruleForm.organizeCode = res.data.organizeCode;
            this.ruleForm.organizeName = res.data.organizeName;
            this.ruleForm.organization = res.data.upOrganizeName;
            this.ruleForm.id = res.data.id;
            this.ruleForm.remark = res.data.remark
            this.ruleForm.status = res.data.status
            this.ruleForm.parentId = res.data.parentId
            if (this.ruleForm.parentId === 0) {
              this.isUpdate = true;
            }
          } else {
            this.$message.error(res.message)
          }
        })
      }
    },
    computed: {
      ...mapGetters([
        'sidebar'
      ])
    },
    mounted() {
      // if (this.$route.query.id) {
      //   this.editEvent(this.$route.query.id)
      // }
    }

  }
</script>

<style lang="scss" >
  #sys-wrapper {
    position: relative;
    .sys-content {
      .el-form-item__label {
        padding-right: 5px !important;
      }
      .el-form-item__error{
        left: 115%;
        width: 200px;
        top: 25%;
      }
      .el-form-item{
        margin-bottom: 10px;
      }

    }
    .sys-footer{
      position: absolute;
      bottom: 0px;
      left: 0px;
      margin-left: 20px;
      height: 60px;
      width: 100%;
    }
    .content-params {
      padding:5px 20px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      overflow: hidden;
      .params {
        min-width:340px;
        margin: 5px 0;
        font-size: 0;
      }
      .custom_label {
        min-width: 80px;
        display:inline-block;
        font-size: 14px;
        font-weight:700;
        text-align: right;
        color:#606266;
        i {
          color: red;
          font-style: normal;
          vertical-align: middle;
        }
      }
    }
}
#order-wrapper{
    .el-date-editor.el-input, .el-date-editor.el-input__inner{
      width:178px!important;
    }
 }
.tabWarp{
  padding:20px 0 0;
  display:flex;
  .el-input{
    width:178px!important;
    margin:5px 0!important;
  }
  label{
    color: #606266;
    font-size: 12px;
    text-align:right;
  }

}
</style>




// WEBPACK FOOTER //
// src/_app/wwka/src/views/orderCheck/created.vue